import React from 'react';
import { GroupGuardrailComplianceCard } from '@internal/backstage-backstage-plugin-guardrail-compliance';
import { DhDockHomepage } from '@internal/backstage-plugin-dh-dock-homepage';
import { Entity } from '@backstage/catalog-model';
import { featureFlagsObj } from '../../hooks/config';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import { HomePage } from './HomePage';
import { productCatalogBaseUrl } from '../../utils';

const getHomepageEditUrl = (entity: Entity) => {
  if (entity.kind.toLowerCase() === 'system') {
    return `${productCatalogBaseUrl}${encodeURIComponent(entity.metadata.name)}`;
  }
  return undefined;
};

export const FlaggedHomePage = () => {
  const { isOn } = useFeatureFlags({
    id: featureFlagsObj['dh-dock-homepage'],
  });

  return isOn ? (
    <HomePage>
      <DhDockHomepage
        getEditUrl={getHomepageEditUrl}
        guardrails={<GroupGuardrailComplianceCard variant="homepage" />}
      />
    </HomePage>
  ) : (
    <HomePage />
  );
};